import { Tooltip } from "@material-ui/core";
import { CustomCellRendererProps } from "ag-grid-react";
import { Color } from "../../../../theme";

export const TextWrapRenderer = <T extends object, K extends keyof T = keyof T>({
  props,
  property,
  valueConverter
}: {
  props: CustomCellRendererProps<T>;
  property: K;
  valueConverter?: (value?: T[K]) => string[];
}) => {
  const characterWrapThreshold = 30;
  const valueDisplayLimit = 6;
  const value = props.data ? props.data[property] : undefined;
  const convertedValue = valueConverter ? valueConverter(value) : value;
  const values: string[] = [];
  const wrappedValues: string[] = [];
  let currentValuesCharacterCount = 0;

  if (Array.isArray(convertedValue)) {
    convertedValue
      .slice()
      .sort((a, b) =>
        typeof a === "string" && typeof b === "string" ? a.length - b.length : 0
      )
      .forEach((v) => {
        if (typeof v === "string") {
          if (
            (currentValuesCharacterCount + v.length > characterWrapThreshold ||
              values.length > valueDisplayLimit) &&
            values.length !== 0
          ) {
            wrappedValues.push(v);
          } else {
            values.push(v);
            currentValuesCharacterCount += v.length;
          }
        }
      });
  }
  return (
    <Tooltip
      title={wrappedValues.length > 0 ? <span> {wrappedValues.join(", ")}</span> : ""}
      placement="top-start"
    >
      <div>
        <span>{values.join(", ")}</span>
        {wrappedValues.length > 0 ? (
          <span style={{ color: Color.PrimaryMain }}> +{wrappedValues.length}</span>
        ) : null}
      </div>
    </Tooltip>
  );
};
